// export const API = "http://127.0.0.1:8000";
export const API = process.env.REACT_APP_BASE_URL;
export const PUBLIC_REVIEW_URL =
  process.env.REACT_APP_PUBLIC_REVIEW_URL ||
  "https://feedback.himalayanjava.com/review";
